import axios from 'axios'

import Echo from 'laravel-echo'

import { API_URL } from '../api'
import { cookies } from './index'
import { 
	AUTH_USER, 
	UNAUTH_USER, 
	GOT_USERDATA,
	CLOSE_MODAL
} from './types'
import { errorHandler } from './actions'
import copy from 'fast-copy'
import { persistor } from 'index.js'

import { doToken } from 'utils'
import { isCordova } from 'env.js'

export function loginUser({ email, password, invitationId }, callback) {
	let invitationIdIfExists = null;

	if(typeof(invitationId) != 'undefined' && invitationId){
		invitationIdIfExists = invitationId;
	}

	return dispatch => {
		axios
		.post(API_URL + '/authenticate', { email, password, invitationIdIfExists })
		.then(response => {
			doToken('set', { 
				token: response.data.token,
				userId: response.data.id
			}, { path: '/' })

			dispatch({
				type: AUTH_USER,
				userData: response.data,
				payload: response.data.id,
				token: response.data.token,
			})

			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: copy(response.data),
				entityType: 'user',
			})

			dispatch({
				type: GOT_USERDATA,
				payload: response.data.id
			})

			callback(null, { ok: true })
		})
		.catch(error => {
			const message = errorHandler(error.response)
			console.log(error)
			callback({ message })
		})
	}
}

export function getUserData(id, callback = null, tokenFromState = null){
	return dispatch => {
		// fixes 'an error occurred' after logging in successfully.
		dispatch({
			type: CLOSE_MODAL,
			errorOnly: true
		})

		if(tokenFromState){
			axios.defaults.headers.common['Authorization'] = 'Bearer '+tokenFromState
		}

		axios.get(API_URL+'/getUserData?id='+id).then(response => {
			// we'll flush the persistor here, and clear out the entity state. Ensures everything's up to date. 
			persistor.purge()

			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data,
				entityType: 'user',
			})

			dispatch({
				type: GOT_USERDATA,
				payload: id
			})

			if(callback){
				callback(false)
			}
		}).catch(error => {
			if(callback){
				callback(true, error.response ? false : true)
			}
		})
	}
}

export function passwordReset(data, callback) {
	return dispatch => {
		axios.post(API_URL + '/password/reset', data)
		.then(response => {
			if (response.data.status === 'fail') {
				callback({ message: response.data.message })
			}

			if (response.data.status === 'success') {
				callback(null, { ok: true })
			}
		})
		.catch(error => {
			callback( error )
			const message = errorHandler(error.response)
		})
	}
}

export function passwordRecover(data, callback) {
	return dispatch => {
		axios
		.post(API_URL + '/password/recover', data)
		.then(response => {
			if (response.data.success) {
				callback(null, { ok: true, message: response.data.data.message })
			}
		})
		.catch(error => {
			if(error.response && error.response.status == 401){
				callback({ 
					message: "That email address couldn't be found."
				})
			}else{
				callback({
					message: "Yikes! An unidentified error has occurred."
				})
			}
    	})
	}
}

export function passwordResetToken(data, callback) {
	return dispatch => {
		axios.post(API_URL + '/password/reset/token', data)
		.then(response => {
			if (response.data.success) {
				callback(null, { ok: true, message: response.data.data.message })
			}
		})
		.catch(error => {
			const message = error.response.data.error.message
			callback({ message })
		})
	}
}

export function logoutUser() {
	return dispatch => {
		doToken('remove','token')
		persistor.purge()

		if(window.FirebasePlugin && isCordova){
			const deviceType = window.device ? window.device.platform : ''

			window.FirebasePlugin.getToken(function(token) {
				axios.post(API_URL+'/user/removePushToken', { 
					token,
					deviceType
				}).catch(error => {
					console.log('TOKEN ERROR')
					console.log(error)
				})
			}, function(error) {
				console.log('Error getting token')
				console.error(error)
			})
		}

		if(window.Echo){
			window.Echo.disconnect()
		}

		dispatch({
			type: UNAUTH_USER,
		})
	}
}

export function getInviteData(inviteId, callback) {
	return dispatch => {
		axios.get(API_URL + '/invitations/get/'+inviteId)
		.then(response => {
			if(response.data !== "TAKEN"){
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'invitation',
				})
			}

			dispatch({
				type: 'INVITE_RECEIVED',
				payload: response.data
			})

			callback(response.data)
		}).catch(error => {
			console.log(error)
			callback(error)
		})
	}
}

export const getReferrer = (emailOrId, type, callback) => {
	return dispatch => {
		axios.get(API_URL+'/user/referrer?email='+emailOrId+'&type='+type)
			.then(response => {
				dispatch({
					type: type == 'referral' ? 'REFERRER_SET' : 'AFFILIATE_SET',
					payload: response.data,
				})

				if(callback){
					callback(response.data)
				}
			}).catch(error => {
				console.log(error)
			})
	}
}

export const clearReferrer = _ => {
	return dispatch => {
		dispatch({
			type: 'REFERRER_SET',
			payload: null
		})
	}
}

export const clearUnsubscribeData = _ => {
	return dispatch => {
		dispatch({
			type: 'UNSUBSCRIBED',
			payload: null
		})
	}
}

export const deletePendingInvitation = inviteId => {
	return dispatch => {
		// maybe we leave it around in case you wanna open it again.
		axios.post(API_URL+'/invitations/dismiss', { inviteId })
		.catch(error => {
			console.log(error)
		})

		dispatch({
			type: 'INVITE_DELETED'
		})
	}
}

export function acceptInvitation(invite, callback = null){
	return dispatch => {
		axios.post(API_URL+'/invitations/accept', { inviteId: invite.id })
		.then(response => {
			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data,
				entityType: 'user',
			})

			if(callback){
				callback()
			}
		}).catch(error => {
			console.log(error)
		})
	}
}

export const setTempUiColour = payload => {
	return dispatch => {
		dispatch({
			type: 'SET_TEMP_UI_COLOUR',
			payload
		})
	}
}

export const toggleSeeComplete = projectId => {
	return dispatch => {
		dispatch({
			type: 'TOGGLE_SEE_COMPLETE',
			payload: projectId
		})
	}
}


// WEBPACK FOOTER //
// ./src/state/actions/auth-actions.jsx